// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_36-1";
export var rateTableServiceLevelDropdown = "_36-3";
export var rateTableTypeDropdown = "_36-0";
export var rateTableValueModeDropdown = "_36-2";